import { useCallback, useMemo } from 'react'
import { useRenderValue } from '@hooks/useRenderValue'

// Bundle of the display formatters a mapper needs. Passed into every mapper so
// the raw -> render-ready transform stays out of components.
export function useFormatters() {
  const renderValue = useRenderValue()

  const formatDate = useCallback((value, options) => {
    if (!value) return ''
    const date = new Date(value)
    if (Number.isNaN(date.getTime())) return ''
    return new Intl.DateTimeFormat(
      undefined,
      options ?? { dateStyle: 'medium', timeStyle: 'short' }
    ).format(date)
  }, [])

  return useMemo(() => ({ renderValue, formatDate }), [renderValue, formatDate])
}
